import { useEffect, useState } from 'react'
import { Space, Button, message, Select } from 'antd';
import { PlusCircleTwoTone, RightOutlined } from '@ant-design/icons';
import { YhBox } from "@/components/YhBox";
import { AddApplyDrawer } from './AddApplyDrawer';
import { AddNodeDrawer } from './AddNodeDrawer';
import { globalPrompt } from "@/components/YhMessage";
import { approvalService } from '../ApprovalService';
import { useApprovalModel } from "../approvalModel";
import { ApprovalFlowNodeFields, ApprovalFlowFields, UserFields, UserJobFields } from '../ApprovalTypes';
import '../approval.less'
import useGlobalModel from '@/model/globalModel';
import { useDictModel } from '../../dict/dictModel';
import { DictCodeEnmu } from '@/types/VrmSaDictEnums';

export const RightEdit = () => {
  const { getSelectedDictOne } = useDictModel();
  const {
    guid, clone, selectedShop,
    setAddNodeDrawer, setAddApplyDrawer,
    selectFlow, setSelectFlow,
    approvalFlows, setApprovalFlows, getShopFlow,
    setApplys,
  } = useApprovalModel()

  const { shopAndOrg: { shopType, shopCode } } = useGlobalModel();

  // 存储每个流程的采购类型选择状态
  const [repairTypeMap, setRepairTypeMap] = useState<Record<string, any>>({});

  // 初始化采购类型数据
  useEffect(() => {
    // 为每个流程初始化采购类型
    approvalFlows.forEach(flow => {
      if (!repairTypeMap[flow.id!]) {
        setRepairTypeMap(prev => ({
          ...prev,
          [flow.id!]: {
            value: flow.purchaseTypeCode || '',
            label: flow.purchaseTypeName || ''
          }
        }));
      }
    });
  }, [approvalFlows]);

  const addApply = (id: string) => {
    let idx = findIndex(approvalFlows, id);
    let flow = approvalFlows[idx];
    setApplys(flow.applys?.map(item => ({
      "name": item.applyName,
      "code": item.applyCode,
      "job": item.applyDuty,
    })));
    setSelectFlow({ "flowId": id });
    setAddApplyDrawer(true);
  }

  const addNode = (id: string, index: number) => {
    let idx = findIndex(approvalFlows, id);
    let flowNodes = approvalFlows[idx].nodes;
    flowNodes?.splice(index, 0, { "id": guid().replaceAll("-", "") });

    setApprovalFlows(clone(approvalFlows));
  }

  const deleteNode = (id: string, index: number) => {
    let idx = findIndex(approvalFlows, id);
    let flowNodes = approvalFlows[idx].nodes;
    flowNodes?.splice(index, 1);

    setApprovalFlows(clone(approvalFlows));
  }

  //根据ID查询在数组中的位置
  const findIndex = (arr: any[], id?: string) => {
    return arr.findIndex(function (obj) {
      return obj.id === id;
    });
  }

  const addNodeDetail = (id: string, index: number, item?: ApprovalFlowNodeFields) => {
    setSelectFlow({ flowId: id, nodeIndex: index });
    setAddNodeDrawer({ visible: true, node: item });
  }

  const handleSubmitNode = (data: ApprovalFlowNodeFields) => {
    let idx = findIndex(approvalFlows, selectFlow?.flowId);
    let flowNodes = approvalFlows[idx].nodes;
    flowNodes?.splice((selectFlow?.nodeIndex ?? 0), 1, data);

    setApprovalFlows(clone(approvalFlows));
  }

  const handleSelectApply = (applys: UserFields[]) => {
    let idx = findIndex(approvalFlows, selectFlow?.flowId);
    approvalFlows[idx].applys = applys?.map(item => ({
      "applyCode": item.code,
      "applyName": item.name,
      "applyDuty": item.job,
    }))
  }

  // 处理采购类型选择变化
  const handleRepairTypeChange = (id: string, value: string, option: any) => {
    let node = {
      label: option.label,
      value: option.value,
    }
    setRepairTypeMap(prev => ({
      ...prev,
      [id]: node
    }));
  }

  const onSubmit = (flow: ApprovalFlowFields) => {
    let flag = true;

    // 根据selectedShop.key进行不同验证
    if (selectedShop?.key === 3) {
      // 采购类型验证
      if (!repairTypeMap[flow.id!]?.value) {
        message.error("请选择采购类型");
        flag = false;
      }
    } else if (selectedShop?.key !== 3) {
      // 申请机构验证
      if (flow.applys == null || flow.applys.length == 0) {
        message.error("请选择申请机构");
        flag = false;
      }
    }

    flow.nodes?.map(item => {
      if (item.nodeTitle == null) {
        message.error("请完善审核节点");
        flag = false;
      }
    });

    if (flag) {
      // 根据不同类型构建参数
      let param = {
        id: flow.id,
        shopCode: flow.shopCode,
        approvalType: selectedShop.key,
        ...(selectedShop?.key === 3 ? {
          applys: [{
            "applyCode": repairTypeMap[flow.id!]?.value,
            "applyName": repairTypeMap[flow.id!]?.label,
            "sort": 0
          }]
        } : {
          applys: flow.applys?.map((item, index) => ({
            ...item,
            "sort": index
          }))
        }),
        nodes: flow.nodes,
      }

      approvalService.update(param).then(res => {
        if (res && res.retData == true) {
          message.success('保存成功');
          getShopFlow(selectedShop.key);
          //清除数据
          setSelectFlow(undefined);
          setApplys([]);
          setApprovalFlows([]);
        }
      }).catch(err => {
        message.error("保存失败" + err);
      })
    }
  }

  const onDelete = (flow: ApprovalFlowFields) => {
    globalPrompt("modal", {
      title: "警告", type: "warning", text: "是否确认删除", onOk: async () => {
        approvalService.delete(flow.id ?? "").then(res => {
          if (res && res.retData == true) {
            message.success('删除成功');
            getShopFlow(selectedShop.key);
            //清除数据
            setSelectFlow(undefined);
            setApplys([]);
            setApprovalFlows([]);
          }
        }).catch(err => {
          message.error("删除失败" + err);
        })
      },
      cancelShow: true,
    })

  }

  return (
    <div style={{ overflow: 'hidden', overflowX: 'scroll', display: 'inline-flex' }}>
      {approvalFlows.map((flow, index) =>
        <YhBox key={flow.id ?? "" + index} title="审批流程" style={{ width: 380, marginLeft: 10, flex: '0 0 auto', overflow: 'auto' }} >
          <div className="right-head">
            <div className="right-head-button">
              <Button
                type="primary"
                shape="round"
                onClick={() => onSubmit(flow)}
              >
                保存
              </Button>
              <Button
                type="primary"
                shape="round"
                onClick={() => onDelete(flow)}
              >
                删除
              </Button>
            </div>
          </div>
          <div className='node-list' >
            {/* 根据selectedShop的key值显示不同内容 */}
            {selectedShop?.key === 3 ? (
              <div className='node' style={{ marginBottom: 30 }}>
                <div className='node-title'>采购类型</div>
                <div className='node-add'>
                  <Select
                    style={{ width: '100%' }}
                    placeholder="请选择采购类型"
                    value={flow.applys?.[0]?.applyCode}
                    onChange={(value, option) => handleRepairTypeChange(flow.id!, value, option)}
                    options={getSelectedDictOne(DictCodeEnmu.PURCHASE_TEPE).filter((opt: any) => !opt.disabled)}
                  />
                </div>
              </div>
            ) : (
              <div className='node' style={{ marginBottom: 30 }}>
                <div className='node-title'>申请机构</div>
                <div className='node-add' onClick={() => { addApply(flow.id ?? "") }}>
                  <div className='node-add-user'>
                    {flow.applys?.map((item) =>
                      <div className='node-add-user-child'>
                        <span className='node-add-user-name'>{item.applyName}</span>
                      </div>
                    )}
                  </div>
                  <span className='node-add-icon'><RightOutlined /></span>
                </div>
              </div>
            )}

            <div className='node'>
              <div className='node-title'>开始</div>
              <div className='node-subtitle'>审批流程开始</div>
            </div>
            <div className='line'>
              <div className='line-button' onClick={() => addNode(flow.id ?? "", 0)}>
                <Space><PlusCircleTwoTone twoToneColor="blue" /></Space>
              </div>
            </div>
            {flow.nodes?.map((item, index) =>
              <div key={item.id}>
                <div className='node' >
                  <div className='node-title'>
                    <div style={{ flex: 8 }}>
                      {item && item.nodeTitle ? item.nodeTitle : '审批节点'}
                    </div>
                    <span style={{ flex: 1, color: "#3333FF", fontSize: 14 }} onClick={() => deleteNode(flow.id ?? "", index)}>删除</span>
                  </div>
                  <div className='node-add' onClick={() => addNodeDetail(flow.id ?? "", index, item)}>
                    <div className='node-add-user'>
                      <div className='node-add-user-child'>
                        <span className='node-add-user-name'>{item?.approvalName ? item.approvalName : '添加'}</span>
                        <span className='node-add-user-duty'>{item?.approvalDuty}</span>
                      </div>
                    </div>
                    <span className='node-add-icon'><RightOutlined /></span>
                  </div>
                </div>
                <div className='line'>
                  <div className='line-button' onClick={() => addNode(flow.id ?? "", index + 1)}>
                    <Space><PlusCircleTwoTone twoToneColor="blue" /></Space>
                  </div>
                </div>
              </div>
            )}
            <div className='node'>
              <div className='node-title'>结束</div>
              <div className='node-subtitle'>审批流程结束</div>
            </div>
          </div>
        </YhBox>
      )}
      <AddApplyDrawer onSelectOk={handleSelectApply} />
      <AddNodeDrawer onSubmitOk={handleSubmitNode} />
    </div>
  )
}
